/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cell-phone': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 3.5C4.5 2.67157 5.17157 2 6 2H13.375C14.2034 2 14.875 2.67157 14.875 3.5V16.5C14.875 17.3284 14.2034 18 13.375 18H6C5.17157 18 4.5 17.3284 4.5 16.5V3.5ZM6 3C5.72386 3 5.5 3.22386 5.5 3.5V16.5C5.5 16.7761 5.72386 17 6 17H13.375C13.6511 17 13.875 16.7761 13.875 16.5V3.5C13.875 3.22386 13.6511 3 13.375 3H10.8673C11.021 3.0853 11.125 3.24925 11.125 3.4375C11.125 3.71364 10.9011 3.9375 10.625 3.9375H8.75C8.47386 3.9375 8.25 3.71364 8.25 3.4375C8.25 3.24925 8.35404 3.0853 8.50775 3H6ZM10.1875 14.6875C10.1875 14.4114 9.96364 14.1875 9.6875 14.1875C9.41136 14.1875 9.1875 14.4114 9.1875 14.6875V14.6969C9.1875 14.973 9.41136 15.1969 9.6875 15.1969C9.96364 15.1969 10.1875 14.973 10.1875 14.6969V14.6875Z" fill="#1F222C"/>'
  }
})
